import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { rubricActions } from '../../../../../store/slices/rubric.slice'

const CreateRubricButton = () => {
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(rubricActions.setShowCreateRubricDrawer(true))
    }

    return (
        <Button
            type='primary'
            icon={<PlusOutlined aria-hidden='true' />}
            onClick={handleClick}
        >
            Create
        </Button>
    )
}

export default CreateRubricButton

